import { numberToShorthandCurrencyString } from '../../../utils';
import { CurrencyCode } from 'further-types/lp/vehicle';

const formatYAxisTick = (value: number, baseCurrency: CurrencyCode) => {
  if (value === 0) {
    return '0';
  }

  return numberToShorthandCurrencyString(value, {
    currency: baseCurrency,
    negativeInBrackets: true,
  });
};

export default formatYAxisTick;
